<div class="img-dialog-container">
    <div class="row">
        <div class="col-md-12">
            <a class="close-icon" mat-dialog-close>
                <i class="fa fa-close"></i>
              </a>
        </div>
    </div>
    <img [src]="data" alt="" />
</div>